module.exports = __webpack_public_path__ + "img/about-10.07bc6d3e.png";